import React from 'react';
import { AuthStatus, useAuthContext } from '@isyc-react/auth/modules/context';
import { BrowserRouter } from 'react-router-dom';
import { RouterLogged } from './logged';
import { RouterUnlogged } from './unlogged';
import { LoaderDotted } from '@isyc-react/form/modules/base';
import { BuConfigProvider, LookAndFeelProvider } from '@isyc-react/oncustomer/modules/objects/business-unit';
import { namespaces } from 'i18n/i18n.constants';
import { ConfigurationProvider } from 'common-app/configuration/configuration.provider';
const basename = '/bailleurs/';
export const Router = () => {
    const { status } = useAuthContext();
    return (React.createElement(BrowserRouter, { basename: basename }, status === AuthStatus.LOADING ? (React.createElement("div", { className: 'vh-100 d-flex align-items-center justify-content-center' },
        React.createElement(LoaderDotted, null))) : status === AuthStatus.LOGGED ? (React.createElement(React.Fragment, null,
        React.createElement(LookAndFeelProvider, null,
            React.createElement(BuConfigProvider, { namespace: namespaces.common, i18n: true },
                React.createElement(ConfigurationProvider, null,
                    React.createElement(RouterLogged, null)))))) : (React.createElement(React.Fragment, null,
        React.createElement(ConfigurationProvider, null,
            React.createElement(RouterUnlogged, null))))));
};
